import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase } from '../../../shared/ComponentBase.js';
import { InjectedStyledComponent } from '../../../shared/InjectedStyledComponent.js';
import { AccessibilityContext } from '../Accessibility/Accessibility.js';
import Image from '../Image/Image.js';

import { IIconConfiguration, IIconProps, IIconState } from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import { ICON_CATEGORY_KEY, ICON_COMPONENT_KEY } from './Icon.meta.js';

export class Icon extends ComponentBase<IIconProps, IIconState, IIconConfiguration> {
	categoryKey = ICON_CATEGORY_KEY;
	componentKey = ICON_COMPONENT_KEY;
	static contextType = AccessibilityContext;

	constructor(props: IIconProps) {
		super(props);
	}
	imageAccessibleProps(accessibilityContext: any) {
		const { accessibilityText, asset } = this.props;
		const props: { [key: string]: any } = {};
		// default the alt to blank to hide the image from screen readers
		props['alt'] = accessibilityText ?? '';
		return props;
	}
	render() {
		const { className, onClick, accessibilityText, ...props } = this.props;
		const accessibilityContext = this.context;
		return (
			<Wrapper className={className}>
				<Image
					className={className}
					onClick={onClick}
					{...props}
					{...this.imageAccessibleProps(accessibilityContext)}
				/>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(Icon), ICON_CATEGORY_KEY, ICON_COMPONENT_KEY);
